import { CHANGE_SUPPORT_ACCESS } from '../actions/actionTypes';

const initialState = {
    change:false
};

export const supportAccessReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_SUPPORT_ACCESS:
            return {
                change: !state.change,
            };
        default:
            return state;
    }
};